import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

import Header from "./components/Header";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Services from "./pages/Services";
import Pricing from "./pages/Pricing";
import Checkout from "./pages/Checkout";
import Confirmation from "./pages/Confirmation";
import Payment from "./pages/Payment";
import MyAccount from "./pages/MyAccount";
import Login from "./pages/Login";
import OneTimeCheckout from "./pages/OneTimeCheckout";
import AboutPage from "./pages/AboutPage";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";

import ScrollToTop from "./components/ScrollToTop";
import "./App.css";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <Router>
        <ScrollToTop />
        <Header />

        {/* Sentinel once, for the scroll-detect logic */}
        <div id="top-sentinel" style={{ position: "relative", height: 1 }} />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<Services />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/confirmation" element={<Confirmation />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/myaccount" element={<MyAccount />} />
          <Route path="/login" element={<Login />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/one-time-checkout" element={<OneTimeCheckout />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogPost />} />
        </Routes>
      </Router>
    </I18nextProvider>
  );
}

export default App;